export default __webpack_public_path__ + "static/media/druket-active.57e14e62.svg";